//import { checkTokenExists, setToken } from '../helpers/auth';
export const SET_COMPANY_TAB = 'SET_COMPANY_TAB';
export const SET_LOCATION_TAB = 'SET_LOCATION_TAB';
export const SET_REMOVAL_TAB = 'SET_REMOVAL_TAB';
export const SET_INSPECTION_STATE = 'SET_INSPECTION_STATE';
export const RESET_INSPECTION_STATE = 'RESET_INSPECTION_STATE';
export const RESET_INSPECTION_TAB_TRANSLATIONS = 'RESET_INSPECTION_TAB_TRANSLATIONS';

export const setInspectionStateAsync = (data) => dispatch => {
  return new Promise(function(resolve) {
    dispatch(setInspectionState(data));
    return resolve();
  });
};

export const setCompanyTab = (tab) => ({
  type: SET_COMPANY_TAB,
  tab
});

export const setLocationTab = (tab) => ({
  type: SET_LOCATION_TAB,
  tab
});

export const setRemovalTab = (tab) => ({
  type: SET_REMOVAL_TAB,
  tab
});

export const setInspectionState = (data) => ({
  type: SET_INSPECTION_STATE,
  data
});

export const resetInspectionState = () => ({
  type: RESET_INSPECTION_STATE
});

export const resetInspectionTabTranslations = () => ({
  type: RESET_INSPECTION_TAB_TRANSLATIONS
});